// extracted by mini-css-extract-plugin
export default {"button":"MenuLink_button__GkjEA"};